import { Button } from "@/components/ui/button"
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog"
import { LoadingButton } from "@/components/ui/common/loading-button"

interface ConfirmationDialogProps {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
    title?: string
    message?: string
    confirmTitle?: string
    isLoading?: boolean
}

export function ConfirmationDialog({
    isOpen,
    onClose,
    onConfirm,
    title = 'Are you sure you want to leave without saving?',
    message = 'This action cannot be undone. do you want to proceed?',
    confirmTitle = 'Confirm',
    isLoading = false
}: ConfirmationDialogProps) {
    return (
        <Dialog open={isOpen} onOpenChange={isLoading ? undefined : onClose}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription className="">{message}</DialogDescription>
                </DialogHeader>
                <DialogFooter className='flex justify-end items-center gap-3  '>
                    <Button 
                        variant="outline" 
                        onClick={onClose} 
                        className="w-[100px] h-8 text-primary hover: font-semibold"
                        disabled={isLoading}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        loading={isLoading}
                        disabled={isLoading}
                        onClick={onConfirm}
                        className="w-[100px] h-8 text-white hover:bg-slate-600 disabled:cursor-not-allowed"
                    >
                        {confirmTitle}
                    </LoadingButton>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
